export default {
  license: {
    // expired: 'The seller license has exprired.',
    // close_button: 'Close'
  },
  cart: {
    title_noproductsincart: 'Кошик товарів порожній.',
    cta_goback: 'Повернутись до списку товарів',
    title_cart: 'Кошик:',
    title_totalamount: 'Загальна сума:',
    title_discountedamount: 'Ціна зі знижкою',
    title_coupon: 'купон',
    coupon_cta_apply: 'вживати',
    coupon_placeholder: 'купон',
    cta_remove_product: 'Remove',
  },
  checkout: {
    title_back: 'Назад',
    title_back_description: 'Повернутись до списку товарів.',
    // total: 'Total',
    // shipping: 'Shipping'
  },
  footer: {
    banner: 'Sell on your own website with <a href="{link}" target="_blank">{name}</a>.'
  },
  form: {
    error_blank: 'Це поле {field} не може бути порожнім',
  },
  payment_list: {
    title_partial: 'Оплатіть тільки частину суми.',
    title_installations: ' Встановлення:',

    option_installment: '{installment} * {currency} with a total of {total}',
    title_paysecurely: 'Платіть безпечно',
    title_securepayment: 'Ваші платежі захищені 256-бітовим шифруванням військового класу.',

    info_emptycart: 'Your cart is empty. Add a product to make a payment.'
  },
  product: {
    title_selection: ' Вибір продукту:',
    title_price: 'Ціна:',
    cta_addtocart: 'Додати до кошика ({price})',
    title_amountselection: ' Кількість товарів:',
    title_closedforsale: 'Продукт тимчасово недоступний.',
    cta_checkoutpage: 'Перейти до оформлення замовлення'
  },
  sort: {
    label: 'Замовлення:',
    default: 'За умовчуванням',
    price_asc: 'Ціна за зростанням',
    price_desc: 'Ціна за спаданням'
  },
  category: {
    label: 'Category:',
    default: 'Default',
  },
  modifiers: {
    unselect: 'Unselect'
  },
  summary: {
    coupon_cta_apply: 'вживати',
    coupon_placeholder: 'купон'
  }
};



// WEBPACK FOOTER //
// ./src/lang/ue.js